export default {
    label_task:{
        en:"Territories",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Territory",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Territory",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Territory",
        bn:'ব্যবহারকারীর বিবরণ'
    },

}